// extracted by mini-css-extract-plugin
export default {"appIcon":"PortfolioIcon_appIcon__n5qdr"};